module.exports = {
    name: 'Nobs',
    logo: 'https://img.genflow.com/nobs/checkout/logo.png',
    vendorUUID: 'b4456492-3a93-11e9-bfcd-0ac0203a1ad8',
    metaData: {
        title: 'Nobs',
        description: 'A fitness app *actually* designed for beginners',
        author: 'GENFLOW',
        url: 'https://www.nobsapp.co.uk/',
        image: 'https://img.genflow.com/nobs/checkout/logo.png',
    },
    theme: {
        colors: {
            primary: '#ef8676',
            text: '#697386',
            ctaText: '#FFFF92',
        },
    },
    analytics: {
        gtag: '',
        facebookPixel: '',
        tagManager: '',
        tapfiliate: '33111-bd68c9',
        // segment: '', - Stored in env
    },
    links: {
        terms: 'https://www.nobsapp.co.uk/pages/terms-and-conditions',
        privacy: 'https://www.nobsapp.co.uk/privacy-policy',
        support: 'https://support.nobsapp.co.uk/hc/en-us',
        genflow: 'https://genflow.com',
        ios: 'https://apps.apple.com/gb/app/nobs/id1559964990',
        android: 'https://play.google.com/store/apps/details?id=com.mountain.nobs',
    },
    forms: {
        errors: {
            existingUser: 'This user already exists, please login.',
            invalidPassword: 'The password needs to have 6 or more characters.',
            unknownError: 'The registration could not be processed.',
            userNotFound: 'Incorrect email/password combination',
        },
    },
    pages: {
        register: {
            title: 'Sign Up to',
            ctaText: 'Register',
            ctaLoadingText: 'Registering',
        },
        login: {
            title: 'Login to',
            ctaText: 'Login',
            ctaLoadingText: 'Logging In',

        },
    },
    products: [
        {
            title: '1 Month',
            product: '1month',
            // product: '1monthsale',
            // coupon: '55Nh3i8r',
            // label: '30% OFF',
        }, {
            title: '3 Months',
            product: '3month',
            // product: '3monthsale',
            // coupon: 'ZLFVAK4F',
            // label: '40% OFF - Best for School of nobs!',
        }, {
            title: '12 Months',
            product: '12month',
            // product: '12monthsale',
            // coupon: 'RaGDWu6g',
            // label: '30% OFF',
        },
    ],
    saleProducts: [
        {
            title: '1 Month',
            product: '1monthsale',
            label: null,
        }, {
            title: '3 Months',
            product: '3monthsale',
            label: null,
        }, {
            title: '12 Months',
            product: '12monthsale',
            label: null,
        },
    ],
};
